import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { post } from "../../controllers/apiController";
import Layout from "../../components/Layout";

const CustomerCreate = () => {
    const [customerName, setCustomerName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");

    useEffect(() => {
        document.title = "Müşteri Ekle | LEVELUP CRM";
    }, []);

    const createCustomer = async () => {
        if (customerName === "" || companyName === "" || customerEmail === "" || customerPhone === "") {
            toast.error("Tüm alanları doldurmalısınız!");
            return;
        }

        try {
            const response = await post("forms/create-customer", {
                nameSurname: customerName,
                companyName: companyName,
                email: customerEmail,
                phone: customerPhone
            });

            // setCustomerName("");
            // setCompanyName("");
            // setCustomerEmail("");
            // setCustomerPhone("");

            toast.success("Müşteri başarıyla eklendi!");
        } catch (err) {
            toast.error("Müşteri oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Manuel Müşteri Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Müşteri Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerName" className="fw-semibold">Adı Soyadı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-user"></i></div>
                                                    <input type="text" className="form-control" id="customerName" placeholder="Müşterinin adını soyadını giriniz." onChange={(e) => setCustomerName(e.target.value)} value={customerName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="companyName" className="fw-semibold">Firma Adı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-briefcase"></i></div>
                                                    <input type="text" className="form-control" id="companyName" placeholder="Varsa müşteri firma adını yazınız." onChange={(e) => setCompanyName(e.target.value)} value={companyName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerEmail" className="fw-semibold">E-Posta Adresi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-mail"></i></div>
                                                    <input type="text" className="form-control" id="customerEmail" placeholder="Müşteri e-posta adresini giriniz." onChange={(e) => setCustomerEmail(e.target.value)} value={customerEmail} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerPhone" className="fw-semibold">Telefon Numarası: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-phone"></i></div>
                                                    <input type="text" className="form-control" id="customerPhone" placeholder="Telefon numarasını başına 0 ekleyerek yazınız." onChange={(e) => setCustomerPhone(e.target.value)} value={customerPhone} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createCustomer} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Müşteri Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
}

export default CustomerCreate;